import { render, staticRenderFns } from "./langSelect.vue?vue&type=template&id=31d9efea&scoped=true&"
import script from "./langSelect.vue?vue&type=script&lang=js&"
export * from "./langSelect.vue?vue&type=script&lang=js&"
import style0 from "./langSelect.vue?vue&type=style&index=0&id=31d9efea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9efea",
  null
  
)

export default component.exports